import { TFlowchartDataLevelFlat } from './level-helper';
export const isDigitalDataExists = (data: TFlowchartDataLevelFlat[], depth: number, name: string, columnName: string, index: number): boolean => {
    // return if data with depth, name, columnName and index exists and columnName matches digital data regex and is not in channel columns
    if (data.some((x, flatIndex) => (x.Depth == depth && x.Name == name && x.ColumnName == columnName && flatIndex == index && x.IsDigital))) {
        return false;
    }
    return true;
};
